import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    target: String,
    text: String
  }

  async copy() {
    let textToCopy = ""

    if (this.hasTextValue) {
      textToCopy = this.textValue
    } else if (this.hasTargetValue) {
      const targetElement = document.querySelector(this.targetValue)
      if (targetElement) {
        textToCopy = targetElement.value || targetElement.innerText || targetElement.textContent
      }
    }

    if (textToCopy) {
      try {
        await navigator.clipboard.writeText(textToCopy)
        
        // Show feedback
        const originalText = this.element.innerHTML
        this.element.innerHTML = '<i class="bi bi-check"></i> Скопировано'
        this.element.classList.add('btn-success')
        this.element.classList.remove('btn-outline-secondary')
        
        setTimeout(() => {
          this.element.innerHTML = originalText
          this.element.classList.remove('btn-success')
          this.element.classList.add('btn-outline-secondary')
        }, 2000)
      } catch (err) {
        console.error('Failed to copy:', err)
      }
    }
  }
}
